import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from '@mui/material';
import { useConfirmDelivery } from '@/queries/useAppraisalDetail';

interface ConfirmDeliveryDialogProps {
  open: boolean;
  onClose: () => void;
  appraisalId: string;
  rowVersion?: string;
  onSuccess: () => void;
  onError: (error: unknown) => void;
}

export function ConfirmDeliveryDialog({
  open,
  onClose,
  appraisalId,
  rowVersion,
  onSuccess,
  onError,
}: ConfirmDeliveryDialogProps) {
  const { mutate, isPending } = useConfirmDelivery(appraisalId);

  const handleConfirm = () => {
    mutate(
      { rowVersion },
      {
        onSuccess: () => {
          onSuccess();
        },
        onError: (error) => {
          onError(error);
        },
      },
    );
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Confirm Delivery</DialogTitle>
      <DialogContent>
        <Typography>
          You are about to confirm receipt of this appraisal. This acknowledges that the appraisal
          has been delivered to you.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="secondary" onClick={onClose} disabled={isPending}>
          Cancel
        </Button>
        <Button onClick={handleConfirm} disabled={isPending}>
          Confirm Delivery
        </Button>
      </DialogActions>
    </Dialog>
  );
}
